import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { EASE } from "./Reveal";
import { waLink } from "../lib";

export default function FloatingCta() {
    return (
        <motion.a
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.7, duration: 0.5, ease: EASE }}
            href={waLink(
                "Hello Science & Surgical, I'd like to enquire about your products.",
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp-cta"
            aria-label="Chat on WhatsApp"
            className="wa-pulse fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-wa text-ink shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110"
        >
            <MessageCircle className="relative z-10 h-6 w-6" />
        </motion.a>
    );
}
